import useResizeObserver from '@skippay/core/hooks/useResizeObserver';
import { be, bm } from '@skippay/core/utils/classUtils';
import React, { PropsWithChildren, useEffect, useRef } from 'react';
import { useEvent } from 'react-use';

import './index.sass';

const MODULE_NAME = 'HeaderOffset';

interface Props {
	onOffsetChange: (offset: number) => void | undefined;
}

function HeaderOffset(props: PropsWithChildren<Props>): JSX.Element {
	const { children, onOffsetChange } = props;

	const headerWrapperRef = useRef<HTMLDivElement>(null);
	const size = useResizeObserver(headerWrapperRef);

	useEffect(() => {
		if (size) {
			onOffsetChange(size.blockSize);
		}
	}, [size, onOffsetChange]);
	
	useEvent('exponea-download-app', () => {
		if (headerWrapperRef.current) {
			onOffsetChange(headerWrapperRef.current.clientHeight)
		}
	})

	return (
		<div className={bm(MODULE_NAME)}>
			<div className={be(MODULE_NAME, 'fixed')}>
				<div ref={headerWrapperRef} className={be(MODULE_NAME, 'headerWrapper')}>
					{children}
				</div>
			</div>
		</div>
	);
}

export default HeaderOffset;
